import { NavItem } from './nav-item/nav-item';

export const navItemsAdmin: NavItem[] = [
  {
    displayName: 'Dashboard',
    iconName: 'dashboard',
    route: '/dashboard',
  },
  {
    navCap: 'Gerenciador',
  },
  {
    displayName: 'Agenda Cultural',
    iconName: 'calendar',
    route: '/agenda-cultural',
  },
  {
    displayName: 'Banners',
    iconName: 'flag-3',
    route: '/banners',
  },
  {
    displayName: 'Restaurantes',
    iconName: 'chef-hat',
    route: '/restaurantes',
  },
  {
    displayName: 'Vouchers',
    iconName: 'ticket',
    route: '/vouchers',
  },

  // {
  //   displayName: 'Pratos',
  //   iconName: 'tools-kitchen',
  //   route: '/',
  // },
  // {
  //   displayName: 'Vouchers',
  //   iconName: 'gift-card',
  //   route: '/',
  // },
  {
    navCap: 'Administrativo',
  },
  //
  //
  // {
  //   displayName: 'E-mail marketing',
  //   iconName: 'mail-forward',
  //   route: '/',
  // },
  // {
  //   displayName: 'Notificações',
  //   iconName: 'bell-ringing',
  //   route: '/',
  // },

  {
    displayName: 'Categorias',
    iconName: 'category',
    route: '/categorias',
  },
  {
    displayName: 'Destaques',
    iconName: 'stars',
    route: '/destaques',
  },

  {
    displayName: 'Sugestões para Você',
    iconName: 'align-box-left-stretch',
    route: '/sugestoes-para-voce',
  },
  {
    displayName: 'Tags',
    iconName: 'tags',
    route: '/tags',
  },
  {
    displayName: 'Usuários',
    iconName: 'users',
    route: '/usuarios',
  },
  {
    displayName: 'Configurações',
    iconName: 'settings',
    route: '/configuracoes',
  },
  {
    displayName: 'Pontuações',
    iconName: 'star',
    route: '/pontuacoes',
  },
  {
    navCap: 'Festivais',
  },
  {
    displayName: 'Brasil Sabor',
    iconName: 'award',
    children: [
      { displayName: 'Dashboard', iconName: 'layout-dashboard', route: '/sabor-brasil/dashboard' },
      { displayName: 'Participantes', iconName: 'building-store', route: '/sabor-brasil/participantes' },
      { displayName: 'Pontuação Manual', iconName: 'star', route: '/sabor-brasil/pontuar-manual' },
      { displayName: 'Transações', iconName: 'arrows-exchange', route: '/sabor-brasil/transacoes' },
    ],
  },
  {
    displayName: 'Notificações',
    iconName: 'bell-ringing',
    route: '/notificacoes',
  },
  {
    navCap: 'Produtos',
  },
  {
    displayName: 'Plano PRO',
    iconName: 'user-star',
    route: '/produtos/plano-pro',
  },

  // {
  //   navCap: 'Importadores',
  // },
  // {
  //   displayName: 'Restaurantes',
  //   iconName: 'database-import',
  //   route: '/importadores/restaurantes',
  // },
  // {
  //   displayName: 'Pratos',
  //   iconName: 'database-import',
  //   route: '/importadores/pratos',
  // },
];
